/**************
 * 全局组件--方法等定义
 *************/

/** 引用全局布局组件 -- 主页-登陆 */
import MainLayout from './layout/MainLayout.vue';  // 主页
import MainLayout2 from './layout/MainLayout2.vue';  // 后台管理

import BlankLayout from './layout/BlankLayout.vue';  // 登陆页

import Mz_Input from './mz_input/index';

import mz_select from './mz_select/index';

import mz_dialog from './mz_dialog/index';

import mz_radio from './mz_radio/index';


export default {
    install(Vue) {
        Vue.component('MainLayout', MainLayout)
        Vue.component('MainLayout2', MainLayout2)
        Vue.component('BlankLayout',BlankLayout)
        Vue.component('MzInput', Mz_Input)
        Vue.component('MzSelect', mz_select)
        Vue.component('MzDialog', mz_dialog)
        Vue.component('MzRadio', mz_radio)
    }
    // install(Vue) {
    //     console.log(Vue)
    // }
}